<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">Letter</div>
    <div class="card-body p-1">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;">#</th>
                    <th style="width: 500px;">Letter Type</th>
                    <th style="width: 500px;">Letter Name</th>
                    <th style="width: 5px;">File</th>
                    <th style="width: 100px;">Generated Date</th>
                    <th style="width: 50px;">Status</th>
                    <th style="width: 50px;">Acknowledge</th>
                    <th style="width: 50px;" [ngClass]="{'colHide': !this.common.CompanyParameterValue.IsESignInAllowed}">ESign</th>
                    <th>Remark</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let TableData of TableDatas; let i = index">
                    <th scope="row" style="width: 5px;">{{i+1}}</th>
                    <td style="width: 500px;">{{TableData['LetterDocumentTypeName']}}</td>
                    <td style="width: 500px;">{{TableData['LetterName']}}</td>
                    <td style="text-align: -webkit-center;width: 50px;">
                        <div style="width: 50px;"><a
                                *ngIf="TableData['LetterGenerationFileName'] != '' && TableData['LetterGenerationFileName'] != null"
                                [href]="TableData['LetterGenerationFileName']" target="_blank"
                                class="bi bi-file-earmark-check  text-primary" style="-webkit-text-stroke: 1px"></a>
                        </div>
                    </td>
                    <td style="width: 100px;">
                        <div style="width: 100px;">{{TableData['GenerationRequestDate']}}</div>
                    </td>
                    <td style="width: 50px;">
                        <span class="badge"
                            [ngClass]="{'success': common.ToLowerCase(TableData['EmployeeApprovalStatus']) == 'approved', 'danger':common.ToLowerCase(TableData['EmployeeApprovalStatus']) == 'rejected','warning':common.ToLowerCase(TableData['EmployeeApprovalStatus']) == 'pending'}">{{TableData['EmployeeApprovalStatus']}}</span>
                    </td>
                    <td style="text-align: -webkit-center;width: 10px;">
                        <div style="width: 80px;" *ngIf="TableData['EmployeeApprovalStatusID'] == 1"><button
                                type="button" class="btn btn-outline-primary btn-sm" (click)="ARAction(i)"><i
                                    class="bi bi-info-square me-1"></i>Action</button></div>
                    </td>
                    <td style="text-align: -webkit-center;width: 10px;align-content:center" [ngClass]="{'colHide': !this.common.CompanyParameterValue.IsESignInAllowed}">
                        <div style="width: 80px;" *ngIf="TableData['EmployeeApprovalStatusID'] == 2 && TableData['IsESignInDone'] == 0 && TableData['IncludeESignIn']">
                            <button type="button" class="btn btn-outline-primary btn-sm" (click)="Esign(i)"><i
                                    class="bi bi-info-square me-1"></i>Esign</button></div>
                        <!-- <i class="bi bi-patch-check-fill success" *ngIf="TableData['EmployeeApprovalStatusID'] == 2 && TableData['IsESignInDone'] == 1 || true"></i> -->
                        <span class="badge success" *ngIf="TableData['EmployeeApprovalStatusID'] == 2 && TableData['IsESignInDone'] == 1"><i class="bi bi-patch-check-fill pe-1"></i>Verified</span>
                    </td>
                    <td>{{TableData['EmployeeRemarks']}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>